import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomLoginComponent } from './custom-login-form/custom-login-form.component';
import { FormErrorsModule, FormRequiredAsterisksComponent, FormRequiredLegendComponent, OutletModule, PasswordVisibilityToggleModule, SpinnerModule } from '@spartacus/storefront';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { FeaturesConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

@NgModule({
  declarations: [CustomLoginComponent],
  imports: [
    CommonModule,
    NgxMaskDirective,
    NgxMaskPipe,
    FormErrorsModule,
    RouterModule,
    ReactiveFormsModule,
        FormRequiredAsterisksComponent,
        FormRequiredLegendComponent,
    I18nModule,
    UrlModule,
    SpinnerModule,
    PasswordVisibilityToggleModule,
    OutletModule,
    FeaturesConfigModule,
  ],
  providers: [provideNgxMask()],
})
export class ComponentsModule {}
